import i18n from "@/Plugins/i18n";

const { t, te } = i18n.global;

export const translateMaybe = (translationKey) =>
    translationKey ? t(translationKey) : "";

export const getTranslationIfExists = (translationKey, value) => {
    return te(translationKey + value) ? t(translationKey + value) : value;
};
